import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ChooseUs from '../components/ChooseUs'
import Faq from '../components/Faq'

function Index() {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const handleWindowLoad = () => setIsLoading(false)
        window.addEventListener('load', handleWindowLoad)
        const timeoutId = setTimeout(() => setIsLoading(false), 2000)
        return () => {
            window.removeEventListener('load', handleWindowLoad)
            clearTimeout(timeoutId)
        }
    }, [])

    // Initialize Swiper for hero carousel
    useEffect(() => {
        if (typeof window !== 'undefined' && window.Swiper) {
            const heroSwiper = new window.Swiper('.banner-active', {
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                speed: 1000,
                navigation: {
                    nextEl: '.banner-button-next',
                    prevEl: '.banner-button-prev',
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                }
            });

            return () => {
                if (heroSwiper) heroSwiper.destroy();
            };
        }
    }, [isLoading]);

    const handlePreloaderClose = () => setIsLoading(false)

    return (
        <div id="no-js">
            {/* preloader start*/}
            {isLoading && (
                <div id="preloader">
                    <div className="preloader-close" onClick={handlePreloaderClose}>x</div>
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                    </div>
                </div>
            )}
            {/* preloader end */}

            {/* Backtotop start */}
            <div className="backtotop-wrap cursor-pointer">
                <svg className="backtotop-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </div>
            {/* Backtotop end */}


            <main>
                {/* Hero area start */}
                <section className="banner__area p-relative z-1">
                    <div className="swiper banner-active hero-fullscreen">
                        <div className="swiper-wrapper">
                            {/* Slide 1 */}
                            <div className="swiper-slide">
                                <div className="banner banner__space hero-fullscreen">
                                    <div className="banner__thumb-bg" style={{backgroundImage: 'url(assets/imgs/banner-2/banner-new-1.webp)'}} ></div>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-xxl-9 col-xl-9 col-lg-10">
                                                <div className="banner__content p-relative z-index-1">
                                                    <span className="banner__sub-title">Authorized Supplier of Entrust Printers & Smart Cards</span>
                                                    <h1 className="banner__title">The Premier Partner for Secure Identity & Card Issuance</h1>
                                                    <p className="h5">
                                                        We specialize in end-to-end identification solutions, from high-performance Entrust Sigma ID Card Printers 
                                                        to premium PVC Hospital OP Cards and Corporate Access Badges.
                                                    </p>
                                                    <div className="banner-home-2__btn__wrapper-2 d-flex flex-wrap mt-40 mt-md-35 mt-sm-30 mt-xs-25">
                                                        <Link to="/printers" className="rr-btn btn-hover-white">Explore Printers</Link>
                                                        <Link to="/contact" className="rr-btn btn-hover-white ml-20">Request a Quote</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Slide 2 */}
                            <div className="swiper-slide">
                                <div className="banner banner__space hero-fullscreen">
                                    <div className="banner__thumb-bg" style={{backgroundImage: 'url(assets/imgs/banner-2/banner-new-2.webp)'}} ></div>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-xxl-9 col-xl-9 col-lg-10">
                                                <div className="banner__content p-relative z-index-1">
                                                    <span className="banner__sub-title">Complete Card Solutions</span>
                                                    <h2 className="banner__title">Custom Smart Cards & ID Solutions for Every Industry</h2>
                                                    <p className="h5">
                                                        From RFID access cards to premium metal cards, we deliver tailored solutions 
                                                        for healthcare, corporate, retail, and education sectors.
                                                    </p>
                                                    <div className="banner-home-2__btn__wrapper-2 d-flex flex-wrap mt-40 mt-md-35 mt-sm-30 mt-xs-25">
                                                        <Link to="/solutions" className="rr-btn btn-hover-white">View Solutions</Link>
                                                        <Link to="/smart-cards" className="rr-btn btn-hover-white ml-20">Smart Cards</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Slide 3 */}
                            <div className="swiper-slide">
                                <div className="banner banner__space hero-fullscreen">
                                    <div className="banner__thumb-bg" style={{backgroundImage: 'url(assets/imgs/banner-2/banner-new-3.webp)'}} ></div>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-xxl-9 col-xl-9 col-lg-10">
                                                <div className="banner__content p-relative z-index-1">
                                                    <span className="banner__sub-title">Complete Your Setup</span>
                                                    <h2 className="banner__title">Premium Accessories for Professional ID Systems</h2>
                                                    <p className="h5">
                                                        Browse our collection of high-quality lanyards, badge reels, and card holders 
                                                        to complete your identification solution.
                                                    </p>
                                                    <div className="banner-home-2__btn__wrapper-2 d-flex flex-wrap mt-40 mt-md-35 mt-sm-30 mt-xs-25">
                                                        <Link to="/accessories" className="rr-btn btn-hover-white">View Accessories</Link>
                                                        <Link to="/contact" className="rr-btn btn-hover-white ml-20">Get Started</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Add navigation arrows */}
                        <div className="banner-nav">
                            <div className="banner-button-prev"><i className="fa-regular fa-arrow-left"></i></div>
                            <div className="banner-button-next"><i className="fa-regular fa-arrow-right"></i></div>
                        </div>
                    </div>
                </section>
                {/* Hero area end */}

                {/* Key Highlights area start */}
                <section className="latest-feature__area pt-80 pb-50 latest-feature-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-6">
                                <div className="latest-feature__item mb-30 d-flex">
                                    <div className="latest-feature__item-icon">
                                        <img src="assets/imgs/feature/feature-img-6.svg" alt="Entrust Sigma Series Printer Icon" />
                                    </div>
                                    <div className="latest-feature__item-content">
                                        <h4>Entrust Sigma Series</h4>
                                        <p>Direct-to-Card & Retransfer printers designed for cloud-ready, secure, and high-speed issuance.</p>
                                        <Link to="/printers">View Printers <i className="fa-solid fa-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6">
                                <div className="latest-feature__item mb-30 d-flex">
                                    <div className="latest-feature__item-icon">
                                        <img src="assets/imgs/feature/feature-img-4.svg" alt="Custom ID Solutions Icon" />
                                    </div>
                                    <div className="latest-feature__item-content">
                                        <h4>Custom ID Solutions</h4>
                                        <p>Hospital OP cards, RFID, NFC, Metal, and Proximity cards tailored to your industry needs.</p>
                                        <Link to="/solutions">View Solutions <i className="fa-solid fa-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6">
                                <div className="latest-feature__item mb-30 d-flex">
                                    <div className="latest-feature__item-icon">
                                        <img src="assets/imgs/feature/feature-img-5.svg" alt="ID Card Accessories Icon" />
                                    </div>
                                    <div className="latest-feature__item-content">
                                        <h4>Accessories</h4>
                                        <p>Complete your look with custom lanyards, badge reels, and holders of premium quality.</p>
                                        <Link to="/accessories">View Accessories <i className="fa-solid fa-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Key Highlights area end */}

                {/* Catalog Navigation Grid */}
                 <section className="service-grid-area pt-120 pb-90 section-bg-2">
                    <div className="container">
                         <div className="row justify-content-center">
                            <div className="col-xl-12">
                                <div className="section-title text-center mb-50">
                                    <h6 className="subtitle">Our Catalog</h6>
                                    <h2 className="title">Explore Our Products</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                 <div className="catalog-card mb-30 wow fadeInUp animated" data-wow-delay=".3s">
                                    <div className="catalog-card-img">
                                        <img src="assets/imgs/catalog/printers.webp" alt="ID Card Printers" />
                                    </div>
                                    <div className="catalog-card-content">
                                        <h4><Link to="/printers">ID Card Printers</Link></h4>
                                        <p>Entrust, Evolis, Zebra, Magicard</p>
                                        <Link to="/printers" className="more-btn">Explore <i className="fa-solid fa-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="catalog-card mb-30 wow fadeInUp animated" data-wow-delay=".5s">
                                    <div className="catalog-card-img">
                                        <img src="assets/imgs/catalog/solutions.webp" alt="Card Solutions" />
                                    </div>
                                    <div className="catalog-card-content">
                                        <h4><Link to="/solutions">Card Solutions</Link></h4>
                                        <p>Hospital, Corporate, Retail</p>
                                         <Link to="/solutions" className="more-btn">Explore <i className="fa-solid fa-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="catalog-card mb-30 wow fadeInUp animated" data-wow-delay=".7s">
                                    <div className="catalog-card-img">
                                        <img src="assets/imgs/catalog/smart cards.webp" alt="Smart Cards" />
                                    </div>
                                    <div className="catalog-card-content">
                                        <h4><Link to="/smart-cards">Smart Cards</Link></h4>
                                        <p>RFID, NFC, Metal, Mifare</p>
                                         <Link to="/smart-cards" className="more-btn">Explore <i className="fa-solid fa-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="catalog-card mb-30 wow fadeInUp animated" data-wow-delay=".9s">
                                    <div className="catalog-card-img">
                                        <img src="assets/imgs/catalog/lanyards.webp" alt="Accessories" />
                                    </div>
                                    <div className="catalog-card-content">
                                        <h4><Link to="/accessories">Accessories</Link></h4>
                                        <p>Lanyards, Badge Reels, Holders</p>
                                         <Link to="/accessories" className="more-btn">Explore <i className="fa-solid fa-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Choose Us / Trust Section (Reused) */}
                <ChooseUs />

                {/* CTA Section */}
                 <section className="cta-area pt-100 pb-100" style={{backgroundColor: 'rgba(74, 163, 223, 0.1)'}}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-8 col-lg-8">
                                <div className="cta-content">
                                    <h2 className="title" style={{color: '#173c5d'}}>Need a Quote for Bulk Orders?</h2>
                                    <p style={{color: '#173c5d'}}>We offer competitive pricing for hospitals, universities, and corporations.</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4">
                                <div className="cta-btn text-lg-end">
                                    <Link to="/contact" className="rr-btn">Get a Quote</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
                {/* FAQ Section */}
                <Faq />
                
            </main>
        </div>
    )
}

export default Index